import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Response }                               from '@angular/http';
import { CsvService }                             from './../../csv.service';
import { ImageService }                           from './../../image.service';
import { ExistingUser, ExistingUserConflicting }  from './../../../../models/program/existing-user';
import { BatchResponse }                          from './../../../../models/program/batch-response';
import { ErrorService }                           from '../../../../shared/services/error.service';
import { SearchService }                          from '../../../../shared/services/search.service';
import { EditionListService }                     from '../../../../editions/edition.service';

import { NewUser } from '../../../../models/program/new-user';
import { NewAndExistingUsers } from '../../../../models/program/new-and-existing-users';

import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-add-users',
  templateUrl: './add-users.component.html',
  styleUrls: ['./add-users.component.less']
})

export class AddUsersComponent {
  @Input() programId?: number;
  @Input() sessionId?: number;
  @Input() addUsersContext: 'add-teams-with-users' | 'add-users-to-edition' | 'assign-users-to-teams' | 'add-users-to-session';
  @Output() postBatch: EventEmitter<any> = new EventEmitter<any>();
  @Output() fromExisting: EventEmitter<NewAndExistingUsers>
    = new EventEmitter<NewAndExistingUsers>();
  public newAndExistingUsersToAdd: NewAndExistingUsers = [];
  public existingInProgram: ExistingUserConflicting[] = [];
  public csv: File;
  public errors: string[];
  public saving: boolean;
  public userBeingCreated = false;

  constructor(
    private csvService: CsvService,
    private errorService: ErrorService,
    private editionListService: EditionListService,
    private searchService: SearchService,
    private imageService: ImageService
  ) {
    if (!this.programId && (this.addUsersContext === 'add-teams-with-users' || this.addUsersContext == 'assign-users-to-teams')) {
      throw new Error("Program Id must be specified when adding users/teams to program");
    }
  }

  public postFile(file: File): void {
    this.csv = file;
  }

  public addByCsv(file: any): void {
    const postFile = this.csv;
    const formData = new FormData();
    this.saving = true;
    formData.append('upload', postFile);
    if (this.addUsersContext === 'add-teams-with-users') {
      this.csvService.postCsvUsersTeams(this.programId, formData)
        .subscribe((batchResponse: BatchResponse) => {
          this.postBatch.emit(batchResponse);
          this.saving = false;
        }, error => {
          this.errors = this.errorService.messages(error);
          this.saving = false;
        });
    } else if (this.addUsersContext === 'assign-users-to-teams') {
      this.csvService.postCsvAssignUsersTeams(this.programId, this.sessionId, formData)
        .subscribe((batchResponse: BatchResponse) => {
          this.postBatch.emit(batchResponse);
          this.saving = false;
        }, error => {
          this.errors = this.errorService.messages(error);
          this.saving = false;
        });
    } else if (this.addUsersContext === 'add-users-to-edition') {
      this.csvService.postCsvUsersSubscription(this.editionListService.getEdition().id, formData)
        .subscribe((batchResponse: BatchResponse) => {
          this.postBatch.emit(batchResponse);
          this.saving = false;
        }, error => {
          this.errors = this.errorService.messages(error);
          this.saving = false;
        });
    } else if (this.addUsersContext === 'add-users-to-session') {
      this.csvService.postCsvUsersSession(this.programId, this.sessionId, formData)
        .subscribe((batchResponse: BatchResponse) => {
          this.postBatch.emit(batchResponse);
          this.saving = false;
        }, error => {
          this.errors = this.errorService.messages(error);
          this.saving = false;
        });
    }
  }

  public getSampleFileUrl(): string {
    if (this.addUsersContext == 'assign-users-to-teams') {
      this.csvService.getTeamAssignmentFileUrl(this.programId, this.sessionId);
    }
    return this.csvService.getSampleFileUrl(this.programId);
  }

  public getSampleFileUrlUploadToEdition(): string {
    let edition = this.editionListService.getEdition();
    return this.csvService.getSampleFileUrlUploadToEdition(edition.id);
  }

  public handleExistingAndNew(updatedExistingAndNew: (ExistingUser | NewUser)[]) {
    this.newAndExistingUsersToAdd = updatedExistingAndNew;
    this.updateConflictsAndValidation();
  }

  public updateConflictsAndValidation(): void {
    this.userBeingCreated = this.newAndExistingUsersToAdd.filter(user => user.id === -1).length > 0 ? true : false;
    let existingUsersToAdd = this.newAndExistingUsersToAdd.filter(user => user.id > 0) as ExistingUser[];
    this.existingInProgram = existingUsersToAdd.filter(existingUserFromArray =>
      existingUserFromArray.groups.some(group => group.program_id === this.programId) ||
      existingUserFromArray.sessions.some(session => session.program_id === this.programId)
    ).map(existingUserFromArray => {
      const conflictingGroups = existingUserFromArray.groups.filter(
          group => group.program_id === this.programId
        );
      const conflictingSessions = existingUserFromArray.sessions.filter(
          session => session.program_id === this.programId
        );
      const conflictingGroup = conflictingGroups.length ? conflictingGroups[0] : null;
      const conflictingSession = conflictingSessions.length ? conflictingSessions[0] : null;

      return {
        ...existingUserFromArray,
        conflictingGroup: conflictingGroup || conflictingSession,
      } as ExistingUserConflicting;
    });
  }

  public removeConflictingUser(userId: number): void {
    this.newAndExistingUsersToAdd = this.newAndExistingUsersToAdd.filter(existingUser => existingUser.id !== userId);
    this.updateConflictsAndValidation()
  }

  public createFromExisting(): void {
    this.fromExisting.emit(
      this.newAndExistingUsersToAdd as NewAndExistingUsers
    );
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/add-users/add-users.component.ts